// extracted by mini-css-extract-plugin
module.exports = {"container":"PageBase-module--container--1gno7","mainheader":"PageBase-module--mainheader--1fZUx","main":"PageBase-module--main--2rMO7"};